import simpleSwitch from './simple-switch.js'

export default [simpleSwitch]
